import { render } from "./RefikaAdmin.vue?vue&type=template&id=42075472&scoped=true"
import script from "./RefikaAdmin.vue?vue&type=script&lang=js"
export * from "./RefikaAdmin.vue?vue&type=script&lang=js"

import "./RefikaAdmin.vue?vue&type=style&index=0&id=42075472&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42075472"]])

export default __exports__